// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as UserRoles from "../../backend/UserRoles.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function SectionRoleDescription(props) {
  let roleOptions = [
    10,
    20,
    50,
    80
  ];
  return <section
    aria-labelledby={"role_description"}
  >
    <h3
      id={"role_description"}
    >
      {"Popis rolí"}
    </h3>
    <dl
      className={Styles.descriptionList.hyphen}
    >
      {roleOptions.map(role => {
        let name = UserRoles.roleI18n(role);
        return <div
          key={name} >
          <dt>
            <dfn>
              {name}
            </dfn>
          </dt>
          <dd>
            {UserRoles.roleDescription(role)}
          </dd>
        </div>;
      })}
    </dl>
  </section>;
}

let make = SectionRoleDescription;

export {
  make,
}
/* Styles Not a pure module */
